module.exports = ".surg-infection-label{width:150px}#mediastinitis-label{display:block;text-align:center;line-height:90px}\n"